import Vue from 'vue'
import VueRouter from 'vue-router'
// 首页
import Index from '../views/index/Index'      
import Solution from '../views/solution/Solution'
// 载体介绍
import Business from '../views/business/Business'
// 园区活动
import Boardhouse from '../views/boardhouse/Boardhouse'
// 入园政策 
import Social1 from '../views/social/Social1'
// 外部链接防止页
import Open from '../views/open/index'

import OpenNew from '../views/open/new'
import FootMarket from '../views/footmarket/index'
import FootMarketNew from '../views/footmarket/new'
// 签名页
import Scenicspot from '../views/scenicspot/index'

// 新表
import NewFormList from '../views/newForm/newFormList'
import JianxiForm from '../views/newForm/jianxiForm'
import JiuyeForm from '../views/newForm/jiuyeForm'
import ZujinForm from '../views/newForm/zujinForm'
Vue.use(VueRouter)

const routes = [
  {
    path: '/solution',
    name: 'Index',
    component: Index,
  },
  {
    path: '/social1',
    name: 'Social1',
    component: Social1,
  },
  {
    path: '/',
    name: 'Solution',
    component: Solution,
  },
  {
    path: '/business',
    name: 'Business',
    component: Business,
  },
  {
    path: '/boardhouse',
    name: 'Boardhouse',
    component: Boardhouse,
  },
  {
    path:'/open',
    name:'Open',
    component:Open,
  },
  {
    path:'/opennew',
    name:'OpenNew',
    component:OpenNew,
  },
  {
    path:'/footmarket',
    name:'FootMarket',
    component:FootMarket,
  },
  {
    path:'/footmarketnew',
    name:'FootMarketNew',
    component:FootMarketNew,
  },
  {
    path:'/scenicspot',
    name:'Scenicspot',
    component:Scenicspot,
  },
  {
    path:'/newFormList',
    name:'NewFormList',
    component:NewFormList,
  },
  {
    path:'/jianxiForm',
    name:'JianxiForm',
    component:JianxiForm,
  },
  {
    path:'/jiuyeForm',
    name:'JiuyeForm',
    component:JiuyeForm,
  },
  {
    path:'/zujinForm',
    name:'ZujinForm',
    component:ZujinForm,
  },
]

const router = new VueRouter({
  routes
})

export default router

